export const ErrorPage = () => <div>404 page</div>;
